
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.5 21.5V23a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5v-1.5m17 0V23a.5.5 0 01-.146.354.5.5 0 01-.354.146h-2a.5.5 0 01-.354-.146A.5.5 0 0115.5 23v-1.5m3.5 0a.5.5 0 00.354-.146A.5.5 0 0019.5 21v-3.293a.5.5 0 00-.146-.353L17.5 15.5h-15L.646 17.354a.5.5 0 00-.146.353V21a.5.5 0 00.5.5h18zm-10.049-11H4.839a.5.5 0 00-.465.314L2.5 15.5m-2 4H5m10 0h4.5m-2.5-6a6.5 6.5 0 100-13 6.5 6.5 0 000 13z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.5 10.5v-7h2a2 2 0 010 4h-2","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    